<template>
  <div class="contenedor-cambio-clave">
    <div class="tarjeta-cambio-clave">
      <h2 class="titulo">{{ esActivacion ? 'Activar cuenta' : 'Recuperar contraseña' }}</h2>
      <p class="subtitulo" v-if="!completado">
        {{ esActivacion
          ? 'Ingresa tu nueva contraseña para activar tu cuenta.'
          : 'Valida el código y define tu nueva contraseña.' }}
      </p>

      <div v-if="mensaje" :class="['alert', exito ? 'alert-success' : 'alert-danger']" role="alert">
        {{ mensaje }}
      </div>

      <form v-if="!completado" @submit.prevent="enviar" class="formulario">
        <div v-if="!esActivacion" class="mb-3">
          <label class="form-label" for="codigo">Código de verificación (6 dígitos)</label>
          <input
            id="codigo"
            v-model.trim="codigo"
            type="text"
            class="form-control"
            maxlength="6"
            inputmode="numeric"
            placeholder="000000"
            required
            :disabled="cargando"
          />
        </div>

        <div class="mb-3">
          <label class="form-label" for="nuevaClave">Nueva contraseña</label>
          <input
            id="nuevaClave"
            v-model="nuevaClave"
            type="password"
            class="form-control"
            minlength="8"
            required
            :disabled="cargando"
          />
        </div>

        <div class="mb-3">
          <label class="form-label" for="confirmarClave">Confirmar contraseña</label>
          <input
            id="confirmarClave"
            v-model="confirmarClave"
            type="password"
            class="form-control"
            minlength="8"
            required
            :disabled="cargando"
          />
        </div>

        <button class="btn btn-primary w-100" type="submit" :disabled="cargando">
          {{ cargando ? 'Procesando...' : (esActivacion ? 'Activar cuenta' : 'Cambiar contraseña') }}
        </button>
      </form>

      <button v-if="completado" class="btn btn-outline-primary w-100" @click="irInicioSesion">
        Ir a iniciar sesión
      </button>
    </div>
  </div>
</template>

<script>
import auth from '@/services/servicioAutenticacion';

export default {
  name: 'ClientCambioClaveToken',
  data() {
    return {
      codigo: '',
      nuevaClave: '',
      confirmarClave: '',
      cargando: false,
      mensaje: '',
      exito: false,
      completado: false
    };
  },
  computed: {
    token() {
      return String(this.$route.query.token || '').trim();
    },
    esActivacion() {
      return this.$route.path.includes('/clientes/cambiar-clave');
    }
  },
  mounted() {
    if (!this.token) {
      this.mensaje = 'Enlace inválido: falta token.';
      this.exito = false;
      this.completado = true;
    }
  },
  methods: {
    validarClave() {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
      return regex.test(this.nuevaClave);
    },
    async enviar() {
      this.mensaje = '';
      this.exito = false;

      if (!this.token) {
        this.mensaje = 'Token inválido o ausente.';
        return;
      }
      if (this.nuevaClave !== this.confirmarClave) {
        this.mensaje = 'Las contraseñas no coinciden.';
        return;
      }
      if (!this.validarClave()) {
        this.mensaje = 'La contraseña debe tener 8+ caracteres, mayúscula, minúscula y número.';
        return;
      }
      if (!this.esActivacion && !/^\d{6}$/.test(this.codigo)) {
        this.mensaje = 'Debes ingresar un código de verificación válido de 6 dígitos.';
        return;
      }

      this.cargando = true;
      try {
        if (this.esActivacion) {
          await auth.activarCuenta(this.token, this.nuevaClave, this.confirmarClave);
        } else {
          await auth.validarCodigoRecuperacion(this.token, this.codigo);
          await auth.cambiarClaveRecuperacion(this.token, this.nuevaClave, this.confirmarClave);
        }

        this.exito = true;
        this.completado = true;
        this.mensaje = this.esActivacion
          ? 'Cuenta activada correctamente. Ya puedes iniciar sesión.'
          : 'Contraseña actualizada correctamente. Ya puedes iniciar sesión.';
      } catch (error) {
        this.exito = false;
        this.mensaje = error?.response?.data?.message || error?.response?.data?.error || 'No se pudo procesar la solicitud.';
      } finally {
        this.cargando = false;
      }
    },
    irInicioSesion() {
      this.$router.push('/iniciar-sesion');
    }
  }
};
</script>

<style scoped>
.contenedor-cambio-clave {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--bg-main, #f8fafc);
}

.tarjeta-cambio-clave {
  width: 100%;
  max-width: 480px;
  background: var(--secondary-bg-main, #ffffff);
  border: 1px solid var(--border-main, #e2e8f0);
  border-radius: 12px;
  padding: 24px;
  box-shadow: var(--shadow-sm, 0 1px 2px 0 rgb(0 0 0 / 0.05));
}

.titulo {
  margin: 0 0 8px;
  color: var(--text-primary, #0f172a);
}

.subtitulo {
  margin-bottom: 16px;
  color: var(--text-secondary, #475569);
}
</style>
